/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisionSdkSubmitVideoResponse } from '../../models/vision-sdk-submit-video-response';

export interface VisionSdkSubmitVideoPost$Params {
  measurementId?: string;
  scanSessionId?: string;
  name?: string;
  partNumber?: number;
  totalParts?: number;
}

export function visionSdkSubmitVideoPost(http: HttpClient, rootUrl: string, params?: VisionSdkSubmitVideoPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<VisionSdkSubmitVideoResponse>> {
  const rb = new RequestBuilder(rootUrl, visionSdkSubmitVideoPost.PATH, 'post');
  if (params) {
    rb.query('measurementId', params.measurementId, {});
    rb.query('scanSessionId', params.scanSessionId, {});
    rb.query('name', params.name, {});
    rb.query('partNumber', params.partNumber, {});
    rb.query('totalParts', params.totalParts, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<VisionSdkSubmitVideoResponse>;
    })
  );
}

visionSdkSubmitVideoPost.PATH = '/VisionSdk/SubmitVideo';
